import * as React from "react";
import { Button, makeStyles, createStyles, Theme } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import WMLogo from "../../assets/icons/WMLogo";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    LogoButton: {
      "borderRadius": 0,
      "& svg": {
        [theme.breakpoints.up("sm")]: {
          width: "12.5rem",
          height: "2.5rem",
        },
        [theme.breakpoints.down("sm")]: {
          width: "7.5rem",
          height: "2.5rem",
        },
      },
    },
  })
);

function WMLogoButton() {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push("/home/");
  };

  return (
    <Button onClick={handleClick} className={classes.LogoButton}>
      <WMLogo fillColor="white" />
    </Button>
  );
}

export default WMLogoButton;
